module.exports = __webpack_public_path__ + "media/images/v3/icon2-33272281b9602bc1f87b88a9cfa85f0a.png";